import { RefreshCw } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { ShellNotice } from '@/shell/shell-notice';

/**
 * «A new version is ready» (#303, part 2), as a shell notice (#956: `NoticeArea` shows it first,
 * above the others).
 *
 * The update is the person's choice, never automatic: a reload under a half-filled form would lose
 * it. «Aggiorna» reloads; the cross hides it until the next load, which then runs the new version
 * anyway. It is announced once without moving the focus. Its line is the whole message, so it has
 * no «Dettagli»: the room goes to «Aggiorna».
 */
export function useNewVersionNotice(available: boolean): ShellNotice | null {
  const { t } = useTranslation('shell');
  const [dismissed, setDismissed] = useState(false);
  if (!available || dismissed) return null;
  return {
    id: 'new-version',
    label: t('newVersion.text'),
    text: t('newVersion.text'),
    icon: RefreshCw,
    live: true,
    action: { label: t('newVersion.reload'), run: () => window.location.reload() },
    dismiss: () => setDismissed(true),
  };
}
